import React , {Component} from 'react';
import ReactDom from 'react-dom';
import Tinderclone from './Tinderclone.js';
import './assets/css/Index.css';

class App extends Component {
  render() {
    return (
      <div>
        <Tinderclone/>
      </div>
    );
  }
}

ReactDom.render(
  <App />,
  document.getElementById("root")
);

export default App;